/**  Utility functions.

Those of generic value should be moved into athlib as soon
as reasonably possible.

*/
// import fs from 'fs'
// import path from 'path'
// import Gettext from 'node-gettext'
// import { po } from 'gettext-parser'

var double = function (stuff) {
  return stuff + stuff
}

var gettext = function (x) {
  return x
}

var treble = function (stuff) {
  return stuff + stuff + stuff
}
// var iaafJumpCodes = new RegExp('^(LJ|PV|TJ|HJ)$', 'i')
// var iaafThrowCodes = new RegExp('^(WT|JT|DT|HT|SP)$', 'i')

// translated from athlib/athlib/utils.py
// mostly unused
/*
var gt = new Gettext()
var gettext = gt.gettext

const translationsDir = '../locales'
const locales = ['en_GB', 'et', 'fr', 'sr_Latn']
const domain = 'django'

locales.forEach((locale) => {
  const fileName = `${domain}.po`
  const translationsFilePath = path.join(translationsDir, locale, 'LC_MESSAGES', fileName)
  const translationsContent = fs.accessSync(translationsFilePath)

  const parsedTranslations = po.parse(translationsContent)
  gt.addTranslations(locale, domain, parsedTranslations)
})
*/

var sorts = (function () {
  var dd = {
    JUMPS: ['HJ', 'PV', 'LJ', 'TJ'],
    THROWS: ['DT', 'JT', 'HT', 'SP', 'WT'],
    MULTI_EVENTS: ['PEN', 'HEP', 'DEC', 'PENI', 'PENWT'],
    STANDARD_MALE_TRACK_EVENTS: ['100', '200', '400', '800', '1500', '5000', '10000', '110H', '400H', '3000SC', '4x100', '4x400'],
    // When listing field events, the Blazer Brigade suggest this should be the order
    FIELD_SORT_ORDER: ['HJ', 'PV', 'LJ', 'TJ', 'SP', 'DT', 'HT', 'JT'],
    FIELDS: [
      ['30', '60', gettext('60m')],
      ['40', '100', gettext('100m')],
      ['50', '200', gettext('200m')],
      ['70', '400', gettext('400m')],
      ['90', '800', gettext('800m')],
      ['100', '1000', gettext('1000m')],
      ['110', '1500', gettext('1500m')],
      ['120', 'Mile', gettext('One Mile')],
      ['140', '3000', gettext('3000m')],
      ['160', '5000', gettext('5000m')],
      ['170', '10000', gettext('10,000m')],
      ['186', '10K', gettext('10km')],
      ['188', '20K', gettext('20km')],
      ['190', 'HM', gettext('Half Marathon')],
      ['200', 'Mar', gettext('Marathon')],

      ['250', '60H', gettext('60m Hurdles')],
      ['248', '60H91.4', gettext('60m Hurdles (91.4cm)')],
      ['251', '60H76.2', gettext('60m Hurdles (76.2cm)')],
      ['252', '60H100', gettext('60m Hurdles (99cm)')],
      ['260', '100H', gettext('100m Hurdles')],
      ['270', '110H', gettext('110m Hurdles')],
      ['268', '110H91.4', gettext('110m Hurdles (91.4cm)')],
      ['269', '110H100', gettext('110m Hurdles (99cm)')],
      ['259', '100H76.2', gettext('100m Hurdles (76.2cm)')],
      ['300', '400H', gettext('400m Hurdles')],
      ['299', '400H84', gettext('400m Hurdles (84.0cm)')],

      ['210', '2000S', gettext('2000m Steeplechase')],
      ['220', '3000S', gettext('3000m Steeplechase')],

      ['420', '3000W', gettext('3000m Race Walk')],
      ['430', '5000W', gettext('5000m Race Walk')],
      ['440', '10000W', gettext('10,000m Race Walk')],
      ['450', '20000W', gettext('20,000 m Race Walk')],
      ['480', '5W', gettext('5km Race Walk')],
      ['490', '10W', gettext('10km Race Walk')],
      ['500', '20W', gettext('20km Race Walk')],
      ['550', '50W', gettext('50km Race Walk')],

      ['560', '4x1', gettext('4x100m Relay')],
      ['580', '4x4', gettext('4x400m Relay')],
      ['612', '4xMED', gettext('Medley Relay')],

      ['310', 'HJ', gettext('High Jump')],
      ['320', 'PV', gettext('Pole Vault')],
      ['330', 'LJ', gettext('Long Jump')],
      ['340', 'TJ', gettext('Triple Jump')],
      ['350', 'SP', gettext('Shot Put')],
      ['345', 'SP3', gettext('Shot Put (3kg)')],
      ['347', 'SP5', gettext('Shot Put (5kg)')],
      ['348', 'SP6', gettext('Shot Put (6kg)')],
      ['360', 'DT', gettext('Discus Throw')],
      ['358', 'DT1.5', gettext('Discus Throw (1.5kg)')],
      ['359', 'DT1.75', gettext('Discus Throw (1.75kg)')],
      ['375', 'HT3', gettext('Hammer Throw (3kg)')],
      ['377', 'HT5', gettext('Hammer Throw (5kg)')],
      ['378', 'HT6', gettext('Hammer Throw (6kg)')],
      ['380', 'HT', gettext('Hammer Throw')],
      ['390', 'JT', gettext('Javelin Throw')],
      ['387', 'JT500', gettext('Javelin Throw (500 g)')],
      ['389', 'JT700', gettext('Javelin Throw (700 g)')],
      ['399', 'Pen', gettext('Pentathlon')],
      ['400', 'Hep', gettext('Heptathlon')],
      ['400', 'Hepi', gettext('Heptathlon (i)')],
      ['401', 'Hepj', gettext('Heptathlon Girls')],
      ['410', 'Dec', gettext('Decathlon')],
      ['411', 'Decj', gettext('Decathlon Junior')],
      ['412', 'Decy', gettext('Decathlon Boys')],

      ['700', 'R', gettext('Reserve')],
      ['802', 'MR', gettext('Mountain Running')],

      ['40 (extra events)', '100', gettext('B-race 100m')],
      ['560 (extra events', '4x1', gettext('B-race 4x100m Relay')],
      ['70 (extra events)', '400', gettext('B-race 400m')]
    ]
  }
  dd.FIELD_EVENTS = dd.JUMPS + dd.THROWS
  dd.STANDARD_FEMALE_TRACK_EVENTS = dd.STANDARD_MALE_TRACK_EVENTS.map(function (x) { return x === '110H' ? '100H' : x })
  return dd
})()

function encodeQueryData (data) {
  var ret = []
  for (var d in data) {
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
  }
  return ret.join('&')
}

module.exports = {sorts, double, treble, encodeQueryData}



// WEBPACK FOOTER //
// ./src/utils.js